'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./~/get-intrinsic/~/has/src/index.js
// module id = 883
// module chunks = 0